import { render, staticRenderFns } from "./EntitiesByRoleFullDetails.vue?vue&type=template&id=7179bd33&scoped=true"
import script from "./EntitiesByRoleFullDetails.vue?vue&type=script&lang=js"
export * from "./EntitiesByRoleFullDetails.vue?vue&type=script&lang=js"
import style0 from "./EntitiesByRoleFullDetails.vue?vue&type=style&index=0&id=7179bd33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7179bd33",
  null
  
)

export default component.exports